import { BaseIcon } from 'src/components/BaseIcon';
import { BaseOverflowMenu } from 'src/components/BaseOverflowMenu';
import React from 'react';
import { TContextMenuProps } from './ContextMenu.types';
import classnames from 'classnames';
import s from './ContextMenu.module.scss';

export const ContextMenu: React.FC<TContextMenuProps> = ({
  relativeElement,
  modalId,
  position,
  items,
}) => {
  return (
    <BaseOverflowMenu
      relativeElement={relativeElement}
      modalId={modalId}
      position={position}
      size="auto">
      {items.map((item, index) => (
        <button
          type="button"
          className={classnames(s.menuItem, {
            'loading-shimmer': item.loading,
          })}
          key={index}
          onClick={item.onClick}
          disabled={item.disabled}>
          <BaseIcon className={s.icon} icon={item.icon} size={15} />
          {item.title}
        </button>
      ))}
    </BaseOverflowMenu>
  );
};
